module.exports = __webpack_public_path__ + "img/code_or_game_design_splash.1d483b6f.jpg";